import { NOTE_MAX_LENGTH } from "Components/Analyses/constants";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, bool, object, string } from "yup";
import { number } from "../Utils/schemaUtils";

export type MovableAssetItemFormType = {
  readonly name: string;
  readonly movableAssetType: string;
  readonly value: number;
  readonly isUsableForGoals?: boolean;
  readonly isCoveredByInsurance?: boolean;
  readonly isUnderFinancing?: boolean;
  readonly note?: string;
  readonly vehicleIdentificationNumber?: string;
  readonly vehicleLicensePlate?: string;
  readonly vehiclePrice?: number;
  readonly companyIdentificationNumber?: string;
  readonly businessSector?: string;
};

export const getMovableAssetItemFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<MovableAssetItemFormType> = (t) => {
  return object({
    name: string().required(t(Resources.Validation.Required)),
    movableAssetType: string().required(t(Resources.Validation.Required)),
    value: number().required(t(Resources.Validation.Required)),
    isUsableForGoals: bool(),
    isCoveredByInsurance: bool(),
    isUnderFinancing: bool(),
    note: string().max(NOTE_MAX_LENGTH, t(Resources.Validation.String.Max, { count: NOTE_MAX_LENGTH })),
    vehicleIdentificationNumber: string(),
    vehicleLicensePlate: string(),
    vehiclePrice: number(),
    companyIdentificationNumber: string(),
    businessSector: string(),
  }).defined();
};
